export const SHOW_QUESTION_MODAL = 'ui/SHOW_QUESTION_MODAL'
